<template>
  <div class="text-center mt-4 row justify-content-center">
    <h3>Bloquear Ingreso</h3>
    <h6 class="mt-5">Ingresa la Matricula o Clave de empleado</h6>
    <form
    autocomplete="off"
    class="mb-5 col-md-6 col-12"
    v-on:submit.prevent="BloquearAlumno">
      <div class="mb-3">
        <input
        :disabled="loading"
        v-model="matricula"
        type="text"
        class="form-control text-center"
        id="matricula" />
      </div>
      <div class="m-3">
        <button
        :disabled="matricula.length==0 || loading"
        type="submit"
        class="btn btn-primary">
          Buscar
          <i
          v-if="loading"
          class="ml-1 fas fa-spinner fa-spin"></i>
        </button>
      </div>
    </form>
  </div>
</template>

<script>
const axios = require('axios');
import {mapState} from 'vuex';
export default {
  data(){
    return {
      loading:false,
      matricula:'',
    }
  },
  methods:{
    BloquearAlumno(){
      var that = this;
      this.loading=true;
      axios.post(process.env.URL_API+'/api/survey/blockStudent', {
        matricula:that.matricula
      },{
        headers: {
          Authorization: 'Bearer ' + this.usuario.token
        }
      })
      .then(function (response) {
        swal('Bloqueado','Se asignó que tiene sintomas','success');
      })
      .catch(function (error) {
        if (error.response) {
          if (error.response.status==401) {
            swal('Favor de Iniciar Sesión','','warning');
          }else if (error.response.status==403) {
            swal('No tienes permiso para realizar esta acción','','warning');
          }else if (error.response.status==400) {
            swal('No ha contestado ninguna encuesta','','warning');
          }else{
            swal('Error','Favor de intentar mas tarde','error');
          }
        }else{
          swal('Error','Favor de intentar mas tarde','error');
        }

      })
      .finally(response=>{
        this.loading=false;
      });
    },
  },
  mounted(){
    if(this.usuario.token==null){
      this.$router.push({name:'Login'});
    }
  },
  computed:{
    ...mapState(['usuario'])
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/Bloquear.vue